import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
var useStyles = makeStyles(function () {
    return createStyles({
        bold: {
            fontWeight: 700,
        },
        semiBold: {
            fontWeight: 600,
        },
        normal: {
            fontWeight: 400,
        },
        default: {
            fontWeight: 'inherit',
        },
    });
});
var validarFontWeigth = function (typeFont) {
    switch (typeFont) {
        case 'bold':
            return useStyles().bold;
        case 'semi-bold':
            return useStyles().semiBold;
        case 'normal':
            return useStyles().normal;
        default:
            return useStyles().default;
    }
};
var CustomStrong = function (_a) {
    var type = _a.type, className = _a.className, children = _a.children;
    return (React.createElement("strong", { className: className + " " + validarFontWeigth(type) }, children));
};
export default CustomStrong;
